import React from 'react'
import {
  getDoNotWaitlistLabel,
  getYesNoLabel,
} from '../../../../containers/common/codeMaster'
import { yesNo } from '../../../../containers/common/constant/classification'
import { LabelGItem, ValueGItem, ConvertFalsyValueToUnfilledValueGItem } from './reservationDetailParts'
import { translate } from '../../../../i18n'
import { GetProjectDetailDto } from '../../../../dataAccess/webApi/dto/projectsDto'
import { INPUT_FIELD_USAGE } from '../../../../containers/common/constant/projectMst'

type CommonDetailContentProps = {
  lunchAcceptFlag: string
  lunchFlag: string
  snackAcceptFlag: string
  snackFlag: string
  immediatelyReservationFlag: string
  postponeCancelWaitAcceptFlag: string
  postponeCancelWaitFlag: string
  projectMst: GetProjectDetailDto
  preferenceProvisionCertificateFlag: string
  formUseReasonUsage: string
  formUseReason?: string
}

const CommonDetailContent:React.FC<CommonDetailContentProps> = (props: CommonDetailContentProps) => {
  return (
    <>
      {/* 給食 */}
      {props.lunchAcceptFlag === yesNo.yes && (
        <>
          <LabelGItem>{translate('system.reservationDetailGItems.label.lunch')}</LabelGItem>
          <ValueGItem>{getYesNoLabel(props.lunchFlag)}</ValueGItem>
        </>
      )}
      {/* おやつ */}
      {props.snackAcceptFlag === yesNo.yes && (
        <>
          <LabelGItem>{translate('system.reservationDetailGItems.label.snack')}</LabelGItem>
          <ValueGItem>{getYesNoLabel(props.snackFlag)}</ValueGItem>
        </>
      )}
      {/* キャンセル待ち可否 */}
      {props.immediatelyReservationFlag === yesNo.no && props.postponeCancelWaitAcceptFlag === yesNo.yes && (
        <>
          <LabelGItem>{translate('system.reservationDetailGItems.label.postponeCancelWait')}</LabelGItem>
          <ValueGItem>{getDoNotWaitlistLabel(props.postponeCancelWaitFlag)}</ValueGItem>
        </>
      )}
      {/** 領収書兼提供証明書の発行希望 */}
      {props.projectMst.provisionCertificateInput !== INPUT_FIELD_USAGE.NO_USE && (
        <>
          <LabelGItem>{translate('system.reservationDetailGItems.label.preferenceProvisionCertificate')}</LabelGItem>
          <ValueGItem>{getYesNoLabel(props.preferenceProvisionCertificateFlag)}</ValueGItem>
        </>
      )}
      {/* 利用事由 */}
      {props.formUseReasonUsage !== INPUT_FIELD_USAGE.NO_USE && (
        <>
          <LabelGItem>{translate('system.reservationDetailGItems.label.formUseReason')}</LabelGItem>
          <ConvertFalsyValueToUnfilledValueGItem value={props.formUseReason} />
        </>
      )}
    </>
  )
}

export default CommonDetailContent